import script from './SdsLink.vue_rollup-plugin-vue=script.js';
import normalizeComponent from '../../node_modules/vue-runtime-helpers/dist/normalize-component.mjs.js';

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',_vm._b({attrs:{"custom":true},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var _obj;

var isActive = ref.isActive;
var href = ref.href;
var navigate = ref.navigate;return [_c('a',_vm._b({staticClass:"sds-link sds-focus",class:( _obj = {}, _obj[_vm.activeClass] = isActive, _obj ),attrs:{"href":_vm.isExternalLink ? _vm.to : href,"target":_vm.isExternalLink ? '_blank' : null,"rel":_vm.isExternalLink ? 'noopener noreferrer nofollow' : null,"data-testid":_vm.dataTestId},on:{"click":function($event){return _vm.handleClick($event, navigate)}}},'a',_vm.$attrs,false),[_vm._t("default")],2)]}}],null,true)},'router-link',_vm.$props,false))};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;
